import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { getTrendingUsersWithUserdata } from '../../../api/channels';

import {
  checkAndSetLoading,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { mergeChannelsWithUserDatas } from '../../../utils/channels';
import { generateChannelCIDKey } from '../../../utils/generateChannelCIDKey';

import { REQUEST } from '../../../constants/request';

export const fetchTrendingUsers = createAsyncThunk(
  `channels/fetchTrendingUsers`,
  async (_, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [trendingUsersRes, trendingUsersUserdataRes] =
        await getTrendingUsersWithUserdata(_, {
          cancelToken: source.token,
        });

      return mergeChannelsWithUserDatas(
        trendingUsersRes,
        trendingUsersUserdataRes,
      );
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: (_, { getState }) => {
      const { channels } = getState();

      return !(
        channels.channels.displayTrendingUsers.request.loading ===
        REQUEST.pending
      );
    },
  },
);

export const fetchTrendingUsersExtraReducers = builder => {
  builder
    .addCase(fetchTrendingUsers.pending, (state, action) => {
      checkAndSetLoading(state.channels.displayTrendingUsers.request, action);
    })
    .addCase(fetchTrendingUsers.fulfilled, (state, action) => {
      onMatchedRequest(
        state.channels.displayTrendingUsers.request,
        action,
        () => {
          const trendingById = action.payload.reduce(
            (accChannel, curChannel) => {
              const channelCIDKey = generateChannelCIDKey(curChannel);
              return {
                ...accChannel,
                [channelCIDKey]: curChannel,
              };
            },
            {},
          );

          state.channels.displayTrendingUsers.layout =
            Object.keys(trendingById);

          const byId = {
            ...state.channels.channel.byId,
            ...trendingById,
          };

          state.channels.channel.byId = byId;
          state.channels.channel.allIds = Object.keys(byId);
        },
      );
    })
    .addCase(fetchTrendingUsers.rejected, (state, action) => {
      handleRequestRejection(
        state.channels.displayTrendingUsers.request,
        action,
      );
    });
};
